<template>
  <div>
    <WheelSlider
      :list="[
        {perspective: 'center', items: days, ref: 'day', selectedIndex: defaultDate.day - 1},
        {perspective: 'center', items: months, ref: 'month', selectedIndex: defaultDate.month - 1},
        {perspective: 'center', items: years, ref: 'year', selectedIndex: selectedYearIndex},
      ]"
      @on-change="handleChange"
    />
  </div>
</template>

<script>
import moment from 'moment'
import WheelSlider from '@/components/base/WheelSlider'

export default {
  name: 'BaseDatePicker',
  components: { WheelSlider },
  props: {
    minYear: {
      type: Number,
      default: 1930,
    },
    maxYear: {
      type: Number,
      default: moment().year() ,
    },
    value: {
      type: String,
      required: true,
    },
  },
  emits: ['input'],
  computed: {
    defaultDate () {
      const defaultDateParts = this.model.split('/')
      const year = parseInt(defaultDateParts[2], 10)

      const day = parseInt(defaultDateParts[1], 10)
      const month = parseInt(defaultDateParts[0], 10)
      const validYear = year >= this.minYear && year <= this.maxYear ? year : this.maxYear
      return ({
        day,
        month,
        year: validYear,
      })
    },
    months(){
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      return months.map((month, index) => {
        return {
          label: month,
          value: index + 1,
        }
      })
    },
    years() {
      return Array.from({ length: this.maxYear - this.minYear + 1 }, (_, i) => {
        const year = this.maxYear - i
        return {
          label: year,
          value: year,
        }
      })
    },
    days() {
      return Array.from({ length: 31 }, (_, i) => ({
        label: i + 1,
        value: i + 1,
      }))
    },
    selectedYearIndex() {
      return this.years.findIndex(year => year.value === this.defaultDate.year)
    },
    model: {
      get() {
        if (this.value) {
          return this.value
        }

        const today = new Date()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        const day = String(today.getDate()).padStart(2, '0')
        const year = today.getFullYear()

        return `${month}/${day}/${year}`
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    handleChange(newDate) {
      let {
        day, month, year,
      } = this.defaultDate

      if (newDate.ref === 'day') {
        day = newDate.selectedValue.value
      }
      if (newDate.ref === 'month') {
        month = newDate.selectedValue.value
      }
      if (newDate.ref === 'year') {
        year = newDate.selectedValue.value
      }

      this.model = `${month}/${day}/${year}`
    },
  },
}
</script>

